/**
 * 成员卡的懒加载壳（21an；GroupNoticeDialogLazy 同构）：只有群聊里点头像才用，
 * 不占首屏块。加载期间渲染 null（块是本地的，点到弹出通常一帧内）。
 */
import { useLazyModule } from './useLazyModule';
import type { MemberCardSheetProps } from './MemberCardSheet';

export function MemberCardSheetLazy(props: MemberCardSheetProps) {
  const { mod } = useLazyModule(() => import('./MemberCardSheet'));
  if (mod === null) return null;
  return <mod.MemberCardSheet {...props} />;
}
